import { createGlobalStyle } from "styled-components";
import { Colors } from "./StyleTypes";
import "react-toastify/dist/ReactToastify.css";

/**
 * Global component for the entire application.
 */
interface GlobalStyleProps {
  showScroll?: boolean;
}

const GlobalStyle = createGlobalStyle<GlobalStyleProps>`
  *,
  *:after,
  *:before {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    text-decoration: none;
    font-size: 100%;
  }

  body {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    overflow: hidden;
    max-height: 100vh;
    font-family: 'Roboto', sans-serif;
    color: ${(props) => props.theme.colors.textPrimary};
    font-size: 14px;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    height: 100dvh;
    width: 100dvw;
    background-color: ${(props) => props.theme.colors.background};

    @media screen and (max-width: 960px) {
      iframe[title='Botão para abrir a janela de mensagens'] {
        display: none;
      }
    }

    #ze-snippet {
      background-color: #dbb434;
      width: 100px;

      #gHHEeh {
        width: 10px;
      }
    }

    .react-joyride__tooltip {
      max-width: 400px !important;
    }

    #root {
      @media screen and (max-width: 960px) {
        height: 100vh;
        height: 100dvh;
        width: 100vw;
        width: 100dvw;
      }
    }

    .gHHEeh {
      width: 10px;
    }

    #ze-snippet .ze-widget-container {
      color: #c41212;
    }

    /* CSS Reset*/
    button,
      input,
      select,
      textarea {
        font: inherit;
    }
  }

  .fGdDiY {
    width: 10px !important;
  }

  /* Toastify */
  .Toastify__toast-container {
    display: flex;
    justify-content: center;
    flex-direction: column;
    width: auto;
    text-align: center;
    line-height: 1.5;

    @media (max-width: 480px) {
      width: 100%;
    }
  }

  .Toastify__toast-icon {
    display: none !important;
  }

  .Toastify__toast-body {
    margin: 10px !important;
    font-family: Roboto, sans-serif;
  }

  .Toastify__toast--success {
    background: #048243 !important;
    color: white !important;
  }

  .Toastify__toast--warning {
    background: yellow;
  }

  .Toastify__toast--error {
    background: #c21618 !important;
    color: white !important;
  }

  .Toastify__toast--info {
    background: #5DAEFF !important;
    color: white !important;
  }

    /**********************************
  ********* ZENDESK WIDGET *********
  **********************************/

  body > div:not(#root) > div > div {
    overflow: unset !important;
  }

  body > div:not(#root) > div > div > iframe {
    box-shadow: 5px 0px 10px #00000080;
    border-radius: 10px;
  }

  body > div:not(#root) > div > iframe {
    position: fixed !important;
    bottom: 20px !important;
    right: 20px !important;
    z-index: 10000 !important;
    display: block !important;
    opacity: 1 !important;
    visibility: visible !important;
  }

  @media screen and (max-device-width: 480px) {
    body > div:not(#root) > div > div > iframe {
      border-radius: 0 !important;
      box-shadow: none !important;
      width: 100vw !important;
      height: 90vh !important;
      top: 0 !important;
      left: 0 !important;
      right: 0 !important;
      bottom: 0 !important;
      position: fixed !important;
      z-index: 9999 !important;
    }

    body > div:not(#root) > div > iframe {
      bottom: 15px !important;
      right: 10px !important;
      z-index: 10000 !important;
      display: block !important;
      opacity: 1 !important;
      visibility: visible !important;
    }
  }

  @media screen and (max-width: 960px) {
    body.mobile-zendesk-tab:not(.mobile-zendesk-open) > div:not(#root) > div > iframe {
      display: none !important;
      opacity: 0 !important;
      pointer-events: none !important;
      visibility: hidden !important;
    }
  }
`;

export default GlobalStyle;
